export { default } from '@esentai/core/features/reconciliationArchiveReceipts/api';
